/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_No_Internet_TitleInputs */

const en_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poor Network Connection`)
};

const ar_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جودة الاتصال بالشبكة ضعيفة`)
};

const de_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlechte Netzwerkverbindung`)
};

const es_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conexión De Red De Baja Calidad`)
};

const fr_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualité De La Connexion Réseau Médiocre`)
};

const it_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connessione Di Rete Scadente`)
};

const ja_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネットワーク接続品質が低い`)
};

const ko_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네트워크 연결 품질이 좋지 않습니다`)
};

const pt_br_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conexão De Rede Fraca`)
};

const ru_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Низкое Качество Сетевого Соединения`)
};

const th_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณภาพการเชื่อมต่อเครือข่ายไม่ดี`)
};

const tr_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ağ Bağlantısı Kalitesi Zayıf`)
};

const zh_cn_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网络连接质量不佳`)
};

const zh_tw_dialog_no_internet_title = /** @type {(inputs: Dialog_No_Internet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`網路連線品質不佳`)
};

/**
* | output |
* | --- |
* | "Poor Network Connection" |
*
* @param {Dialog_No_Internet_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_no_internet_title = /** @type {((inputs?: Dialog_No_Internet_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_No_Internet_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_no_internet_title(inputs)
	if (locale === "ar") return ar_dialog_no_internet_title(inputs)
	if (locale === "de") return de_dialog_no_internet_title(inputs)
	if (locale === "es") return es_dialog_no_internet_title(inputs)
	if (locale === "fr") return fr_dialog_no_internet_title(inputs)
	if (locale === "it") return it_dialog_no_internet_title(inputs)
	if (locale === "ja") return ja_dialog_no_internet_title(inputs)
	if (locale === "ko") return ko_dialog_no_internet_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_no_internet_title(inputs)
	if (locale === "ru") return ru_dialog_no_internet_title(inputs)
	if (locale === "th") return th_dialog_no_internet_title(inputs)
	if (locale === "tr") return tr_dialog_no_internet_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_no_internet_title(inputs)
	return zh_tw_dialog_no_internet_title(inputs)
});